import { graphql } from "~/gql";

export const DELETE_PHASE = graphql(/* GraphQL */ `
  mutation deletePhase($phaseId: Float!) {
    deletePhase(phaseId: $phaseId) {
      phaseId
    }
  }
`);

export const DELETE_PHASES = graphql(/* GraphQL */ `
  mutation deletePhases($phaseIds: [Int!]!) {
    deletePhases(phaseIds: $phaseIds) {
      phasesIds
    }
  }
`);
